import React, { useEffect, useRef } from "react";
import "./scrollup.css";

const ScrollUp = () => {
  const scrollUp = useRef(null);

  useEffect(() => {
    window.addEventListener("scroll", function () {
      if (this.scrollY >= 560) scrollUp.current.classList.add("show-scroll");
      else scrollUp.current.classList.remove("show-scroll");
    });
  });

  return (
    <a href="#home" ref={scrollUp} className="scrollup">
      <i className="uil uil-arrow-up scrollup__icon"></i>
    </a>
  );
};

export default ScrollUp;
